'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'microphone-slash';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f131';
var svgPathData = 'M479.1 256l-.0004-48c0-8.801-7.199-16-15.1-16c-8.801 0-15.1 7.199-15.1 16l.0002 48c0 6.172-1.047 12.06-1.895 17.1l28.12 22.2C477.6 283.3 479.1 269.1 479.1 256zM255.1 96c0-35.25 28.75-64 63.1-64S383.1 60.75 383.1 96v128.1l31.1 25.26L415.1 96c0-53-43-96-95.1-96S223.1 43 223.1 96l-.0001 2.645l31.1 25.26V96zM633.9 483.4L25.92 3.42C18.98-2.033 8.92-.8301 3.436 6.061C-2.033 12.1-.8457 23.06 6.076 28.54L614.1 508.6C617 510.9 620.5 512 623.1 512c4.734 0 9.422-2.094 12.58-6.078C642 498.1 640.8 488.9 633.9 483.4zM399.1 480h-63.1v-65c21.21-2.135 41.09-8.607 59.05-18.2l-27.98-22.09c-17.16 6.842-35.98 10.34-55.82 9.045C243.2 379.1 191.1 319.6 191.1 251.5V236.5L159.1 211.2v39.15c0 83.38 61.62 156.1 143.1 164.4V480H239.1c-8.801 0-16 7.199-16 16C223.1 504.8 231.2 512 239.1 512h159.1c8.801 0 15.1-7.201 15.1-15.1C415.1 487.2 408.8 480 399.1 480z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMicrophoneSlash = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/pro-light-svg-icons/faMicrophoneSlash.js
// module id = wkbQ
// module chunks = 0